(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["driftwood-transport-quotes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const link = event.target.closest('[data-dw-quote]');
 if (!link) return;
 const select = document.getElementById('dw-quote-service');
 if (select) { select.selectedIndex = link.dataset.dwQuote === 'rental' ? 1 : 0; select.focus({preventScroll:true}); }
});
  } catch(e) { console.error(e); }
})();

})();
